"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var allKeys = [
    { code: 'Backspace', name: 'backspace' },
    { code: 'Tab', name: 'tab' },
    { code: 'Enter', name: 'enter' },
    { code: 'ShiftLeft', name: 'shift' },
    { code: 'ControlLeft', name: 'ctrl' },
    { code: 'AltLeft', name: 'alt' },
    { code: 'CapsLock', name: 'caps' },
    { code: 'Escape', name: 'escape' },
    { code: 'Space', name: 'space' },
    { code: 'PageUp', name: 'pageUp' },
    { code: 'PageDown', name: 'pageDown' },
    { code: 'End', name: 'end' },
    { code: 'Home', name: 'home' },
    { code: 'ArrowLeft', name: 'left' },
    { code: 'ArrowUp', name: 'up' },
    { code: 'ArrowRight', name: 'right' },
    { code: 'ArrowDown', name: 'down' },
    { code: 'Insert', name: 'insert' },
    { code: 'Delete', name: 'delete' },
    { code: 'Digit0', name: 'zero' },
    { code: 'Digit1', name: 'one' },
    { code: 'Digit2', name: 'two' },
    { code: 'Digit3', name: 'three' },
    { code: 'Digit4', name: 'four' },
    { code: 'Digit5', name: 'five' },
    { code: 'Digit6', name: 'six' },
    { code: 'Digit7', name: 'seven' },
    { code: 'Digit8', name: 'eight' },
    { code: 'Digit9', name: 'nine' },
    { code: 'KeyA', name: 'A' },
    { code: 'KeyB', name: 'B' },
    { code: 'KeyC', name: 'C' },
    { code: 'KeyD', name: 'D' },
    { code: 'KeyE', name: 'E' },
    { code: 'KeyF', name: 'F' },
    { code: 'KeyG', name: 'G' },
    { code: 'KeyH', name: 'H' },
    { code: 'KeyI', name: 'I' },
    { code: 'KeyJ', name: 'J' },
    { code: 'KeyK', name: 'K' },
    { code: 'KeyL', name: 'L' },
    { code: 'KeyM', name: 'M' },
    { code: 'KeyN', name: 'N' },
    { code: 'KeyO', name: 'O' },
    { code: 'KeyP', name: 'P' },
    { code: 'KeyQ', name: 'Q' },
    { code: 'KeyR', name: 'R' },
    { code: 'KeyS', name: 'S' },
    { code: 'KeyT', name: 'T' },
    { code: 'KeyU', name: 'U' },
    { code: 'KeyV', name: 'V' },
    { code: 'KeyW', name: 'W' },
    { code: 'KeyX', name: 'X' },
    { code: 'KeyY', name: 'Y' },
    { code: 'KeyZ', name: 'Z' },
    { code: 'OSLeft', name: 'superLeft' },
    { code: 'OSRight', name: 'superRight' },
    { code: 'ContextMenu', name: 'menu' },
    { code: 'Numpad0', name: 'num0' },
    { code: 'Numpad1', name: 'num1' },
    { code: 'Numpad2', name: 'num2' },
    { code: 'Numpad3', name: 'num3' },
    { code: 'Numpad4', name: 'num4' },
    { code: 'Numpad5', name: 'num5' },
    { code: 'Numpad6', name: 'num6' },
    { code: 'Numpad7', name: 'num7' },
    { code: 'Numpad8', name: 'num8' },
    { code: 'Numpad9', name: 'num9' },
    { code: 'NumpadMultiply', name: 'multiply' },
    { code: 'NumpaddAdd', name: 'add' },
    { code: 'NumpaddDivide', name: 'divide' },
    { code: 'NumpadDecimal', name: 'point' },
    { code: 'NumpadMinus', name: 'minus' },
    { code: 'F1', name: 'F1' },
    { code: 'F2', name: 'F2' },
    { code: 'F3', name: 'F3' },
    { code: 'F4', name: 'F4' },
    { code: 'F5', name: 'F5' },
    { code: 'F6', name: 'F6' },
    { code: 'F7', name: 'F7' },
    { code: 'F8', name: 'F8' },
    { code: 'F9', name: 'F9' },
    { code: 'F10', name: 'F10' },
    { code: 'F11', name: 'F11' },
    { code: 'F12', name: 'F12' },
    { code: 'NumLock', name: 'numLock' },
    { code: 'ScrollLock', name: 'scrollLock' },
    { code: 'Semicolon', name: 'semiColon' },
    { code: 'Equal', name: 'equals' },
    { code: 'Comma', name: 'comma' },
    { code: 'Minus', name: 'dash' },
    { code: 'Period', name: 'dot' },
    { code: 'Slash', name: 'forewardSlash' },
    { code: 'BracketLeft', name: 'openBracket' },
    { code: 'IntlBackslash', name: 'backSlash' },
    { code: 'BracketRight', name: 'closeBracket' },
    { code: 'Quote', name: 'quote' },
    { code: 'MetaLeft', name: 'metaLeft' }
];
exports.default = allKeys;
